import React from 'react'

import { useMutateBookmarkVideo } from '../../../../hocs/content/useVideos'
import { useToaster } from '../../../../libraries/toaster'
import { useI18N } from '../../../../libraries/i18n/hook'
import BookmarkButton from '../../../components/content/BookmarkButton'


type Props = { id: number, bookmarked?: boolean, children?: string }
const BookmarkButtonContainer: React.FC<Props> = ({ id, bookmarked, children }) => {
  const { t } = useI18N()
  const { showSuccess } = useToaster()
  const { trigger: submitBookmark } = useMutateBookmarkVideo(id?.toString())

  const handleToggleBookmark = async () => {
    await submitBookmark({ saved: !bookmarked, videoId: id.toString() })
    showSuccess(!bookmarked ? t('content.bookmarked.success') : t('content.unbookmarked.success'))
  }

  return (
    <BookmarkButton onClick={handleToggleBookmark} bookmarked={bookmarked}>{children}</BookmarkButton>
  )
}

export default BookmarkButtonContainer
